import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  notification,
  Menu,
  Input,
  Dropdown,
  Modal
} from "antd";

import { SearchOutlined, DownOutlined } from "@ant-design/icons";

import { getDiscountCodes, getDiscountCodeDetail, deleteDiscountCode } from "../api/discount.service";
import { useEffect, useState } from "react";
import EditDiscountCodeModal from "../components/forms/discount/EditDiscountCodeModal";
import AddDiscountCodeModal from "../components/forms/discount/AddDiscountCodeModal";

const { Title } = Typography

function DiscountCodes({ match }) {

  const tourId = match.params.id;

  // Helper function to add search functionality for a column
  const getColumnSearchProps = (dataIndex, placeholder, renderField) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${placeholder}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const recordValue = renderField ? renderField(record) : record[dataIndex];
      return recordValue
        ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
  });

  const handleConfirm = async (id) => { 
    try {
      await deleteDiscountCode(id);
      fetchVehicles();
      notification.success({ message: 'Discount Code deleted successfully' });
    } catch (err) {
      notification.error({ message: 'Failed to delete Discount Code' });
    }
  }
  const getVehicleDataDelete = async (id) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to delete this?",
      okText: "Confirm",
      cancelText: "Cancel",
      onOk() {
        handleConfirm(id)
      },
      onCancel() {
        console.log("Cancelled");
      },
    });
  } 

  const columns = [
    {
      title: "DISCOUNT CODE",
      dataIndex: "discountCode",
      key: "discountCode",
      width: "25%",
      ...getColumnSearchProps("name", "Discount Code", (record) => record.discountCode),
      render: (text, record) => (
        <div className="avatar-info">
          <Title level={5}>{record.discountCode}</Title>
        </div>
      ),
    },
    {
      title: "DISCOUNT %",
      dataIndex: "discountPercent",
      key: "discountPercent",
      width: "25%",
      ...getColumnSearchProps("discountPercent", "Discount %", (record) => record.discountPercent),
      render: (text, record) => (
        <div className="author-info">
          <Title level={5}>{record.discountPercent}</Title>
        </div>
      ),
    },
    {
      title: "ACTIONS",
      width: "25%",
      render: (text, record) => {
        const menu = (
          <Menu>
            <Menu.Item key="view" onClick={() => getVehicleData(record.id, true)}>
              View
            </Menu.Item>
            <Menu.Item key="edit" onClick={() => getVehicleData(record.id)}>
              Edit
            </Menu.Item>
            <Menu.Item key="delete" onClick={() => getVehicleDataDelete(record.id)}>
              Delete
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu}>
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              Tasks <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const [discountCodes, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [vehicleData, setVehicleData] = useState(null);
  const [isViewOnly, setisViewOnly] = useState(false);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const data = await getDiscountCodes();
      setVehicles(data?.data || []); // Set the fetched discountCodes data
    } catch (err) {
      notification.error({ message: 'Failed to fetch discountCodes' });
      setError('Failed to fetch discountCodes');
    } finally {
      setLoading(false);
    }
  };

  const getVehicleData = async (id, isViewOnly = false) => {
    setisViewOnly(isViewOnly)
    const data = await getDiscountCodeDetail(id);
    setVehicleData(data.data);
    setIsModalOpenEdit(true);
  }

  useEffect(() => {
    fetchVehicles();
  }, []);

  useEffect(() => {
    if (tourId) {
      getVehicleData(tourId, true)
    }
  }, [tourId])

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false);
  };

  return (
    <>
      {vehicleData && <EditDiscountCodeModal isViewOnly={isViewOnly} vehicleData={vehicleData} fetchVehicles={fetchVehicles} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
      <AddDiscountCodeModal fetchVehicles={fetchVehicles} handleCancel={handleCancel} handleOk={handleOk} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <div className="mb-3 flex justify-end">
        <Button type="primary" onClick={showModal}>
          Add Discount Code
        </Button>
      </div>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Discount Codes Table"
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={discountCodes}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default DiscountCodes;
